import "./OpenReportDialogButtonComponent.scss";
import template from "./OpenReportDialogButtonComponent.html";
import {IComponentOptions, IOnDestroy, IRootElementService} from "angular";
import {AccountId} from "../../../../../account/types/AccountRecord";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";
import {ReplaySubject} from "rxjs";
import {CurrentUser} from "../../../../../services/user/models/CurrentUser";
import {Branding} from "../../../../../types/Branding";
import {OpenTraderReportsDialog} from "../../dialog/OpenTraderReportsDialog";

export const OpenReportDialog = "tfOpenOtReportDialogButton";

export function openReportDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            accountId: "<"
        },
        controllerAs: "ctrl",
        controller: OpenReportDialogButtonComponentController
    };
}

export class OpenReportDialogButtonComponentController implements IOnDestroy {

    /** @input */
    public readonly accountId: AccountId | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly openTraderReportsDialog: OpenTraderReportsDialog) {
        this.watchSkin();
    }

    private watchSkin() {
        this.currentUserService
            .current
            .takeUntil(this.destroyed$)
            .map((u) => this.isVisibleToUser(u))
            .startWith(false)
            .subscribe((visible) => {
                if (visible) {
                    this.$element.removeClass("hidden");
                } else {
                    this.$element.addClass("hidden");
                }
            });
    }

    private isVisibleToUser(user: CurrentUser): boolean {
        const visibleSkins = [
            Branding.OPEN_MARKETS,
            Branding.OPEN_TRADER,
            Branding.BELLMONT,
            Branding.FUTURE_ASSIST
        ];
        return visibleSkins.some((s) => user.isBranding(s));
    }

    public open() {
        try {
            if (this.accountId != null) {
                this.openTraderReportsDialog.open(this.accountId);
            }
        } catch (e) {
            // Ignored
        }
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
